/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Action_Bar_Waiting_After_RoundInputs */



/**
* | output |
* | --- |
* | "Round {n} complete. Check in for next round." |
*
* @param {Action_Bar_Waiting_After_RoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const action_bar_waiting_after_round = /** @type {((inputs: Action_Bar_Waiting_After_RoundInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Bar_Waiting_After_RoundInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ronde ${i?.n} terminée. Pointez pour la prochaine ronde.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Ronda ${i?.n} completada. Haga check-in para la siguiente ronda.`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Rodada ${i?.n} completa. Faça o check-in para a próxima rodada.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Round ${i?.n} completato. Fai il check-in per il prossimo round.`)
	return /** @type {LocalizedString} */ (`Round ${i?.n} complete. Check in for next round.`)
});